import type { Api } from '@/app/api'

const PAGE_SIZE = 100

/**
 * `entries_list` carries no total and no `hasMore` (AGENTS.md, "Cursors are opaque"), so the
 * only way to know how many entries a merge will move is to page through every result and
 * count them - acceptable here since it only runs once, right before a merge confirmation.
 */
export async function countMerchantEntries(
  api: Api,
  ledgerId: string,
  merchantId: string,
  signal?: AbortSignal,
): Promise<number> {
  let count = 0
  let cursor: string | undefined
  for (;;) {
    const result = await api.entries.list(
      ledgerId,
      { merchantId, limit: PAGE_SIZE, ...(cursor === undefined ? {} : { cursor }) },
      signal,
    )
    count += result.items.length
    if (result.nextCursor === undefined) return count
    cursor = result.nextCursor
  }
}
